// src/createBlockquotePlugin.ts
import {
  createPluginFactory,
  onKeyDownToggleElement
} from "@udecode/plate-common";
var ELEMENT_BLOCKQUOTE = "blockquote";
var createBlockquotePlugin = createPluginFactory({
  key: ELEMENT_BLOCKQUOTE,
  isElement: true,
  deserializeHtml: {
    rules: [
      {
        validNodeName: "BLOCKQUOTE"
      }
    ]
  },
  handlers: {
    onKeyDown: onKeyDownToggleElement
  },
  options: {
    hotkey: "mod+shift+."
  }
});
export {
  ELEMENT_BLOCKQUOTE,
  createBlockquotePlugin
};
//# sourceMappingURL=index.mjs.map